import { render, staticRenderFns } from "./InstallationHistory.vue?vue&type=template&id=084b7923&scoped=true"
import script from "./InstallationHistory.vue?vue&type=script&lang=js"
export * from "./InstallationHistory.vue?vue&type=script&lang=js"
import style0 from "./InstallationHistory.vue?vue&type=style&index=0&id=084b7923&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084b7923",
  null
  
)

export default component.exports